import Http from '@/libs/axios'
import moment from 'moment'
import Vue from 'vue'

export default {
  namespaced: true,
  state: {
    items: [],
    item: null,
    itemSelectOptions: []
  },
  getters: {
    items: state => {
      return state.items
    },
    itemSelectOptions: state => {
      return state.itemSelectOptions
    }
  },
  mutations: {
    SET_ITEM_LIST(state, items) {
      state.items = items
    },
    SET_ITEM(state, item){
      state.item = item
    },
    SET_SELECT_OPTIONS(state, items) {
      let listOfObjects = Object.keys(items).map((key) => {
        return items[key]
      })

      listOfObjects.map((index, item) => {
        return { value: index, text: item }
      })

      state.itemSelectOptions = listOfObjects
    },
  },
  actions: {
    getSelectOptions({commit, dispatch}){
      return new Promise((resolve, reject) => {
        Http.get('agent/select-options').then(response => {
          commit('SET_SELECT_OPTIONS', response.data)
          resolve()
        }).catch(error => reject(error))
      })
    },
    getList({commit}, {params}){
      return new Promise((resolve, reject) => {
        Http.get('agent', { params: params }).then(response => {
            commit('SET_ITEM_LIST', response.data)
            resolve()
        }).catch(error => reject(error))
      })
    },

    show({ commit }, { id }){
      return new Promise((resolve, reject) => {
        Http:get(`agent/${id}`).then(response => {
          commit('SET_ITEM', response.data)
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    create({ }, { payload } ){
      payload.DateStart = moment(payload.DateStart).format('YYYY-MM-DD')
      return new Promise((resolve, reject) => {
        Http.post('agent', payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    update({ }, { payload } ){
      payload.DateStart = moment(payload.DateStart).format('YYYY-MM-DD')
      return new Promise((resolve, reject) => {
        Http.put(`agent/${payload.custno}`, payload).then(response => {
          resolve(response)
        }).catch(error => reject(error))
      })
    },

    destroy({ }, { id } ){
      console.log('delete')
      return new Promise((resolve, reject) => {
        Http.delete(`agent/${id}`).then(response => {
        resolve(response)
        }).catch(error => reject(error))
      })
    },
  },
}
